import {
  type OrchestratedAuctionListingDetails,
  type OrchestratedOfferingListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import {
  AnalyticsEntityType,
  AnalyticsSource,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

import { AccordionCard } from '@/buyer-portal/components/layouts/CardLayout/card/AccordionCard'
import { CardBody } from '@/buyer-portal/components/layouts/CardLayout/card/ui'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

import { LotDescription } from './LotDescription'

export const LotDescriptionCard = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { trackButtonClicked } = useAnalytics()

  if (!listing.lot.description) {
    return null
  }

  const handleLinkClicked = (href: string) => {
    trackButtonClicked({
      buttonName: 'external_link',
      entity_type: AnalyticsEntityType.BUYER,
      link_url: href,
      listing_id: listing._id,
      screenName: 'listing_detail_page',
      seller_display_name: listing.seller.account.displayName,
      source: AnalyticsSource.HOME_PORTAL,
      storefront_id: listing.storefrontId,
      storefront_name: listing.seller.storefront?.name,
    })
  }

  return (
    <AccordionCard title={<FormattedMessage id="Auction.title.description" />}>
      <CardBody>
        <LotDescription
          description={listing.lot.description}
          linkClickedHandler={handleLinkClicked}
        />
      </CardBody>
    </AccordionCard>
  )
}
